import {IPerfStatsSnapshot} from "./SceneStats.types";

export const pcbModeStats: {
    perfSnapshot?: IPerfStatsSnapshot;
    timeToFirstFramesInMs?: number;
} = {};
